let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '统计日期',
        props: 'statisDate',
        minWidth: 220,
    },
    {
        label: '充电订单总数',
        props: 'chargeCountAll',
        minWidth: 200,
    },
    {
        label: '环比',
        props: 'yoyAll',
        minWidth: 180,
        formatter: function formatter(row, column, cellValue, index) {
            row.yoyAll = String(row.yoyAll)
            if(row.yoyAll.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.yoyAll.substring(1)*100).toFixed(2)+'%'
            }else if(row.yoyAll.indexOf('-')>-1) {
                console.log(row.yoyAll.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.yoyAll.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.yoyAll*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '增长量',
        props: 'increaseAll',
        minWidth: 150,
        formatter: function formatter(row, column, cellValue, index) {
            row.increaseAll = String(row.increaseAll)
            if(row.increaseAll.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.increaseAll.substring(1)*100).toFixed(2)+'%'
            }else if(row.increaseAll.indexOf('-')>-1) {
                console.log(row.increaseAll.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.increaseAll.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.increaseAll*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '桩主充电订单总数',
        props: 'chargeCountMaster',
        minWidth: 180,
    },
    {
        label: '桩主充电占比',
        props: 'ratioMaster',
        minWidth: 200,
    },
    {
        label: '桩主充电环比',
        props: 'yoyMaster',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            row.yoyMaster = String(row.yoyMaster)
            if(row.yoyMaster.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.yoyMaster.substring(1)*100).toFixed(2)+'%'
            }else if(row.yoyMaster.indexOf('-')>-1) {
                console.log(row.yoyMaster.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.yoyMaster.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.yoyMaster*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '桩主充电增长量',
        props: 'increaseMaster',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            row.increaseMaster = String(row.increaseMaster)
            if(row.increaseMaster.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.increaseMaster.substring(1)*100).toFixed(2)+'%'
            }else if(row.increaseMaster.indexOf('-')>-1) {
                console.log(row.increaseMaster.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.increaseMaster.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.increaseMaster*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '亲友充电订单总数',
        props: 'chargeCountFamily',
        minWidth: 180,
    },
    {
        label: '亲友充电占比',
        props: 'ratioFamily',
        minWidth: 200,
    },
    {
        label: '亲友充电环比',
        props: 'yoyFamily',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            row.yoyFamily = String(row.yoyFamily)
            if(row.yoyFamily.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.yoyFamily.substring(1)*100).toFixed(2)+'%'
            }else if(row.yoyFamily.indexOf('-')>-1) {
                console.log(row.yoyFamily.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.yoyFamily.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.yoyFamily*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '亲友充电增长量',
        props: 'increaseFamily',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            row.increaseFamily = String(row.increaseFamily)
            if(row.increaseFamily.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.increaseFamily.substring(1)*100).toFixed(2)+'%'
            }else if(row.increaseFamily.indexOf('-')>-1) {
                console.log(row.increaseFamily.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.increaseFamily.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.increaseFamily*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '私桩共享充电订单总数',
        props: 'chargeCountShare',
        minWidth: 180,
    },
    {
        label: '私桩共享充电占比',
        props: 'ratioShare',
        minWidth: 200,
    },
    {
        label: '私桩共享充电环比',
        props: 'yoyShare',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            row.yoyShare = String(row.yoyShare)
            if(row.yoyShare.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.yoyShare.substring(1)*100).toFixed(2)+'%'
            }else if(row.yoyShare.indexOf('-')>-1) {
                console.log(row.yoyShare.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.yoyShare.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.yoyShare*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '私桩共享充电增长量',
        props: 'increaseShare',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            row.increaseShare = String(row.increaseShare)
            if(row.increaseShare.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.increaseShare.substring(1)*100).toFixed(2)+'%'
            }else if(row.increaseShare.indexOf('-')>-1) {
                console.log(row.increaseShare.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.increaseShare.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.increaseShare*100).toFixed(2)+'%'
            }
        }
    },
    
];

// // 面包屑
pageConfig.listBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    }, {
        type: 'title',
        name: '运营分析',
    },
        {
        type: 'title',
        name: '充电订单信息',
    },
    {
        type: 'title',
        name: '充电订单报表'
    }, 
    {
        type: 'title',
        name: '充电订单类型列表'
    }, 
];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: false,
    showIndex: false,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}

// 列表-详情操作
// pageConfig.tableDetailObj = {
//     editKey: 'id',
//     editRouter: 'pileDetailTab',
// };

// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'id',
    editRouter: 'pileDetail',
};

// 路由
pageConfig.listRouter = 'pileList';

pageConfig.reportDetailRouter = 'pileReportDetail';

pageConfig.chargeDetailRouter = 'pileChargeDetail';

pageConfig.repairListDetail = 'repairListDetail';

pageConfig.faultDetail = 'faultDetail';

//维修新增路由
pageConfig.repairAddRouter = 'repairAddDetail';

//维修路由
pageConfig.repairRouter = 'repairDetail';

// 关联账号
pageConfig.relationNum = 'relationNum';

// 详情的面包屑
pageConfig.detailBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '充电管理',
    },
    {
        type: 'router',
        name: '充电桩管理',
        router: 'pileList'
    },
    {
        type: 'title',
        name: '充电桩详情'
    }
];

// 关联账号 详情面包屑
pageConfig.relationBreadCrunm = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '充电管理',
    },
    {
        type: 'router',
        name: '充电桩管理',
        router: 'pileList'
    },
    {
        type: 'title',
        name: '关联账号详情'
    }
]

pageConfig.formRules = {
    pileCode: [{ required: true, message: '请输入IMEI号', trigger: 'blur' }],
    pileTypeNo: [{ required: true, message: '请选择充电桩型号名称', trigger: 'change' }],
    currentOutType: [{ required: true, message: '请选择电流输出类型', trigger: 'change' }],
    gunNum: [{ required: true, message: '请输入充电桩枪数', trigger: 'blur' }],
    //dealName: [{ required: true, message: '请选择经销商名称', trigger: 'change' }],
    optType: [{ required: true, message: '请选择充电桩类型', trigger: 'change' }],
    chargingSpeed: [{ required: true, message: '请选择充电速度', trigger: 'change' }],
    interfaceType: [{ required: true, message: '请选择接口标准', trigger: 'change' }],
    applyReason: [{ required: true, message: '请填写申请原因', trigger: 'blur' }],
    repairPerson: [{ required: true, message: '请填写维修人', trigger: 'blur' }],
    repairStatus: [{ required: true, message: '请选择维修状态', trigger: 'change' }],
    repairResult: [{ required: true, message: '请选择维修结果', trigger: 'change' }],
    repairDateNum: [{ required: true, message: '请填写维修时间', trigger: 'blur' }],
    corpReturn: [{ required: true, message: '请填写运营商回执', trigger: 'blur' }],
};



export default pageConfig;
